import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap, TimelineLite} from "gsap";
import {PearlHarbor} from "../../PearlHarbor";
import {PearlHarborReelView} from "../../reels/PearlHarborReelView";
import {PearlHarborSoundManager} from "../../sound/PearlHarborSoundManager";

export class PearlHarborFillUpReelsPresentation implements FlowStatePresentation {
    private _tl: TimelineLite

    private skip(): void {
        if (this._tl) {
            this._tl.progress(1);
        }
        PearlHarbor.allReelsView.landingTLs.forEach((landingTL: TimelineLite) => {
            landingTL.progress(1);
        });
    }

    start(flowStateController: FlowStateController) {
        this._tl = new TimelineLite();
        //const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => flowStateController.finish()});
        this._tl.add(() => {
            flowStateController.setSkipCallback(() => this.skip());
            PearlHarborReelView.landingSymbolArray.length = 0;
        }, 0.1);
        const subFillUpReelsTLs: TimelineLite[] = [];
        PearlHarbor.allReelsView.landingTLs.length = 0;
        PearlHarborSoundManager.avalancheReelCounter = 0;
        for (let i: number = 0; i < PearlHarbor.allReelsView.mainReelModels.length; i++) {
            const reelTl = PearlHarbor.allReelsView.mainReelModels[i].getFillUpReelAnimation();
            if(reelTl.duration() > 0) {
                PearlHarborSoundManager.avalancheReelCounter++;
            }
            subFillUpReelsTLs.push(reelTl);
        }
        this._tl.add(subFillUpReelsTLs);
        //this._tl.to({}, {duration: 100});
        this._tl.add(() => {
            PearlHarbor.scatterAnimation.checkActiveScatter();
            for(let i:number = 0; i<7; i++){
                PearlHarbor.allReelsView.mainReelModels[i].reelView.setSymbolActiveState()
            }
        }, "+=0.1");
        if (this._tl.duration() == 0) {
            this._tl.add(gsap.to(this, {duration: 0.001}));
        }
        this._tl.add(() => flowStateController.finish());
    }
}